export enum IMAGE_TYPE {
  THUMB = 'thumb',
  ICON = 'icon',
}
